import { useCountryCode } from 'hooks/useCountryCode';
import { MuiTelInput, matchIsValidTel } from 'mui-tel-input';
import { useController } from 'react-hook-form';
import { DEFAULT_FIELD_PROPS } from '../types';

export const PhoneField: React.FC<{ name?: string }> = ({ name }) => {
  const { countryCode } = useCountryCode();
  const {
    field: { ref: fieldRef, value, ...fieldProps },
    fieldState: { error }
  } = useController({
    name: name ?? 'phoneNumber',
    rules: {
      required: 'Please enter a phone number.',

      validate: value => {
        return matchIsValidTel(value)
          ? true
          : 'Please enter a valid phone number.';
      }
    }
  });
  return (
    <MuiTelInput
      {...DEFAULT_FIELD_PROPS}
      {...fieldProps}
      value={value ?? ''} // example +351 999 999 999
      inputRef={fieldRef}
      defaultCountry={name ? undefined : countryCode}
      required={true}
      helperText={error?.message}
      error={!!error}
      label="Phone Number"
    />
  );
};
